import React from 'react';

import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Card, Col, Container, Row } from 'react-bootstrap';

import { ApiGet, ApiPatch, ApiPost } from '../../helper/API/ApiData';
import { useForm } from "react-hook-form"
import FormInput from '../../components/form/FormInput';
import { toast } from 'react-toastify';

interface FieldOption {
    field: {
        type: string;
    }

}

const AddUpdateMember = () => {

    const navigate = useNavigate()

    const [fields, setFields] = useState({})

    const memberId = new URLSearchParams(window.location.search).get("id")
    const isUpdateRequest = !!memberId

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
        setValue,
        setError,
    } = useForm()

    const onSubmit = (data: any) => {
        if (isUpdateRequest) {
            ApiPatch(`member/${memberId}`, data)
                .then((res: any) => {
                    if (res.status === 200) {
                        toast.success("Successfully updated member")
                        navigate('/shgadmin/member/')
                    }
                }).catch((error) => {
                    if (error.status === 400 && error.code === 'validation_error') {
                        error.data.validation.body.keys
                        setError(error.data.validation.body.keys[0],
                            { type: "server", message: error.data.validation.body.message },
                            { shouldFocus: true })
                    }
                    return error
                })
        }
        else {
            ApiPost('member/add', data)
                .then((res: any) => {
                    if (res.status === 200) {
                        toast.success("Successfully created member")
                        // Clear all fields
                        reset()
                        navigate('/shgadmin/member/')
                    }
                }).catch((error) => {
                    if (error.status === 400 && error.code === 'validation_error') {
                        error.data.validation.body.keys
                        setError(error.data.validation.body.keys[0],
                            { type: "server", message: error.data.validation.body.message },
                            { shouldFocus: true })
                    }
                    return error
                })
        }
    }
    useEffect(() => {
        if (isUpdateRequest) {
            // Get member details
            ApiGet(`member/id/${memberId}`)
                .then((res: any) => {
                    if (res?.status === 200) {
                        const memberData = res.data[0]
                        Object.keys(memberData).map((key) => {
                            setValue(key, memberData[key], { shouldValidate: true, shouldTouch: true });
                        })
                    }
                })
                .catch((error) => {
                    return error
                })
        }

        // Getching field names
        ApiGet('member/add')
            .then((res: any) => {
                if (res?.status === 200) {
                    setFields(res.data)
                }
            })
            .catch((error) => {
                return error
            })
    }, [])

    return (
        <Container fluid className="">
            <h3 className='heading-txt m-3'>{isUpdateRequest ? "Update Member" : "Add Member"}</h3>
            <Card className="p-3" style={{ borderRadius: 10 }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='General_Info border-none'>
                        <Row>
                            {Object.entries(fields).map(([fieldName, fieldOptions]: [string, unknown | any], index) => {
                                return (
                                    <Col key={index} xl={4} lg={4} md={6} className="mt-3">
                                        <FormInput name={fieldName} fieldOptions={fieldOptions}
                                            control={control} errors={errors} />
                                    </Col>
                                )
                            })}
                        </Row>
                        <Row className='d-flex justify-content-center mt-3' >
                            <div className='d-flex justify-content-center'>
                                <button className='btn' style={{ backgroundColor: "#082979", color: "#fff" }} type="submit" name="submit">
                                    {isUpdateRequest ? "Update Member" : "Add Member"}
                                </button>
                            </div>
                        </Row>
                    </div>
                </form>

            </Card>
        </Container>
    );
};

export default AddUpdateMember;